<template>
  <div
    class="category-products--main-page category-products"
    :class="{'category-products--cabinet': isCabinet}">
    <ul class="category-products-wrap__item">
      <li
        class="category-products__card"
        v-for="(product, i) in products"
        :key="product.id">
        <product-card
          @onIntersecting="$emit('cardInViewportEvent', $event)"
          :is-preorder="product.is_preorder"
          :id="product.id"
          :position="i + 1"
          :code="product.code.toString()"
          :title="product.title"
          :title-analytics="product.title"
          :category-id="product.category_id"
          :category-parent-id="product.category_parent_id"
          :link="product.link"
          :image-url="product.image_url"
          :gallery="product.gallery"
          :second-image-url="product.second_image_url"
          :rating="product.rating"
          :reviews-count="product.reviews_count"
          :price="JSON.stringify(product.price)"
          :is-available="product.is_available"
          :is-novelty="product.is_novelty"
          :is-in-wait-list="product.is_in_wait_list"
          :is-in-wish-list="product.is_in_wish_list"
          :badges="JSON.stringify(product.badges)"
          :bottom-badge="product.bottom_badge"
          :options="product.options"
          :characteristics="product.characteristics ? product.characteristics : []"
          :arrival-date="product.arrival_date"
          :arrival-date-employee="product.arrival_date_employee"
          :block="transliterate(titleAnalytics)"
          :analytics-data="product.analytics_data"
          :available-in-store="product.available_only_in_store_data"
          :esputnik-data="product.esputnik_data"
          :esutnik-block-id="esputnikBlockId"
          :progressbar-total="product.progressbar_total"
          :progressbar-current="product.progressbar_current"
          not-adaptive
          adaptive-main-page
        />
      </li>
      <slot name="observer"></slot>
      <content-loader
        class="category-products__card category-products__card--skeleton category-products__card--skeleton-mobile"
        v-for="index in shownSkeletons"
        :key="'main-page-mobile-' + index"
        :width="120"
        :height="211"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect
          x="0"
          y="0"
          rx="5"
          ry="5"
          width="120"
          height="120" />
        <rect
          x="0"
          y="129"
          rx="3"
          ry="3"
          width="99"
          height="16" />
        <rect
          x="0"
          y="150"
          rx="3"
          ry="3"
          width="120"
          height="16" />
        <rect
          x="0"
          y="191"
          rx="3"
          ry="3"
          width="67"
          height="20" />
        <rect
          x="90"
          y="181"
          rx="3"
          ry="3"
          width="30"
          height="30" />
      </content-loader>
      <content-loader
        class="category-products__card category-products__card--skeleton category-products__card--skeleton-desktop"
        v-for="index in shownSkeletons"
        :key="index"
        :height="380"
        :width="278"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect
          x="30"
          y="10"
          rx="13"
          ry="13"
          width="220"
          height="220" />
        <rect
          x="20"
          y="271"
          rx="3"
          ry="3"
          width="238"
          height="13" />
        <rect
          x="20"
          y="290"
          rx="3"
          ry="3"
          width="123"
          height="13" />
        <rect
          x="20"
          y="337"
          rx="3"
          ry="3"
          width="90"
          height="24" />
      </content-loader>
      <slot name="handler"></slot>
    </ul>
  </div>
</template>

<script>
import { transliteration } from '@/mixins/transliteration'

import { ContentLoader } from 'vue-content-loader'
import ProductCard from '../product-card/ProductCard'

export default {
  name: 'ProductsSimpleList',
  mixins: [transliteration],
  components: {
    ContentLoader,
    ProductCard
  },
  props: {
    products: {
      type: Array,
      default: () => []
    },
    titleAnalytics: {
      type: String,
      default: ''
    },
    shownSkeletons: {
      type: [String, Number],
      default: 0
    },
    isCabinet: {
      type: Boolean,
      default: false
    },
    esputnikBlockId: String
  }
}
</script>

<style scoped>

</style>
